import { render, staticRenderFns } from "./custom-form-field.vue?vue&type=template&id=6b035b86&scoped=true&"
import script from "./custom-form-field.vue?vue&type=script&lang=js&"
export * from "./custom-form-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b035b86",
  null
  
)

export default component.exports